/** Always refetch configuration payloads; do not treat disk/in-memory as durable. */
export const SPECTRAL_WORKSPACE_QUERY_STALE_TIME = 0;
/** Keep in-memory briefly during SPA navigation (not persisted to IDB). */
export const SPECTRAL_WORKSPACE_QUERY_GC_TIME = 30 * 60 * 1000;
